export default __webpack_public_path__ + "static/burredpetals-63e8cf784a3e1371535c2b66859dc3ed.png";